import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';

import { useUser } from '../../../Store';
import { DATE_FORMAT } from '../../../environment.config';
import * as UserAction from '../../../Store/Actions/User';
import { ERROR, SUCCESS_MESSAGE } from '../../../Constants';

import './UserAccessLink.scss';
import { QRCodeSVG } from 'qrcode.react';
import { copyToClipboard } from '../../../Utils';

export const UserAccessLink = () => {
  const user = useUser(useParams().userId);
  const { t } = useTranslation();
  const [accessCode, setAccessCode] = useState<{code: string, expiresAt: string}>(null);
  const [link, setLink] = useState<string>();

  useEffect(() => {
    setLink(`${origin}/Login/Code/${accessCode?.code}`);
  }, [accessCode]);
  const dispatch = useDispatch();

  const createAccessCode = () => {
    UserAction.resetUserMagicLink(user.user.name)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch({ type: SUCCESS_MESSAGE, data: { message: null } });
          setAccessCode(response.data.magicLink);
          toast.success(t('message.userSaved'));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: ERROR,
            data: { error_msg: error.response.data.message },
          });
        } else {
          dispatch({
            type: ERROR,
            data: { error_msg: error.message.toString() },
          });
        }
      });
  };

  return (
    <div className='agent_body full_width'>
      <div className='header_box'>
        <span className='sub_header_text'>{ user.user.name }</span>
      </div>

      { accessCode && (
        <div className='magic_link_box'>

          <div className="qr-container">
            <QRCodeSVG
              value={link}
              size={200}
              level="M"
              includeMargin
            />
          </div>

          <div className="link">{link}</div>
          <div className="copy">
            <button onClick={() => copyToClipboard(link)}>{t('accessLink.copyLink')}</button>
            <button onClick={() => copyToClipboard(accessCode?.code)}>{t('accessLink.copyCode')}</button>
          </div>
          <div className="expires">{t('label.expiresAt')}: {moment(accessCode?.expiresAt).format(DATE_FORMAT)}</div>
        </div>
      )}
      { !accessCode && (
        <button onClick={() => createAccessCode()}>{t('accessLink.create')}</button>
      )}
    </div>
  );
};
